export default "https://cdn-static.gokick.com/assets/28dce4dd80241a45018c00057f67470c3fae89ba/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";